module.exports = __webpack_public_path__ + "static/sparda-8a023367698b711c7491c95e448f16c5.png";